module.exports = __webpack_public_path__ + "img/side_heart.fd33156f.png";